import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'documentMusk',
  standalone: false
})
export class DocumentMuskPipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      value = value.toUpperCase().replace(/^(AR|CL|UY|BR|RG|DNI)+/g, '')
      value = value.replace(/[-.,;/\\-_#]/g, '').toUpperCase();

      return value;
    }
    return value;
  }
}
